<div style="max-width:560px;">
  <!-- Header gradiente -->
  <div style="background:linear-gradient(135deg,#f0fdf4,#ecfdf5);padding:18px 22px;border-bottom:2px solid #bbf7d0;display:flex;align-items:center;justify-content:space-between;">
    <div class="flex items-center gap-2">
      <mat-icon style="color:#1C593D;">receipt_long</mat-icon>
      <span style="font-size:1rem;font-weight:700;color:#1e5a3f;">Detalle — Op #{{ t.txId }}</span>
    </div>
    <span class="px-3 py-1 inline-flex text-xs font-bold rounded-full"
      [style.background]="getStatusBg(estadoDe(t))" [style.color]="getStatusColor(estadoDe(t))">{{ estadoLabel(estadoDe(t)) }}</span>
  </div>

  <div style="padding:18px 22px;max-height:72vh;overflow-y:auto;">

    <!-- Operación -->
    <div class="det-block">
      <div class="det-title">Operación</div>
      <div class="det-row"><span>Fecha</span><b>{{ t.fecha | date:'dd/MM/yyyy HH:mm' }}</b></div>
      <div class="det-row"><span>Ruta</span><b>{{ t.origen.moneda }}<span *ngIf="t.origen.pais"> ({{ t.origen.pais }})</span> → {{ t.destino.moneda || '—' }}<span *ngIf="t.destino.pais"> ({{ t.destino.pais }})</span></b></div>
      <div class="det-row"><span>Envía</span><b>
        <ng-container *ngIf="t.origen.moneda === 'CLP'">{{ t.montoOrigen | number:'1.0-0' }} CLP</ng-container>
        <ng-container *ngIf="t.origen.moneda !== 'CLP'">{{ t.montoUsd | number:'1.2-2' }} USD</ng-container>
      </b></div>
      <div class="det-row"><span>Tasa</span><b>
        <ng-container *ngIf="t.origen.moneda === 'CLP'">{{ t.tasaCliente | number:'1.2-2' }} COP/CLP</ng-container>
        <ng-container *ngIf="t.origen.moneda !== 'CLP'">{{ t.tasaEfectiva | number:fmtDe(t) }}</ng-container>
      </b></div>
      <div class="det-row" *ngIf="t.origen.moneda === 'CLP'" style="color:#64748b;"><span>Puente USD (interno)</span><b>{{ t.montoUsd | number:'1.2-2' }} USD @ {{ t.interno.origenUsdRate | number:'1.0-2' }} CLP/USD</b></div>
      <div class="det-row highlight"><span>Recibe</span><b>{{ recibeDe(t) | number:fmtDe(t) }} {{ monedaDe(t) }}</b></div>
      <div class="det-row"><span>Vita ID</span><b>{{ t.vitaTxId || '—' }}</b></div>
      <!-- Ticks del cron de verificación (cada 5 min mientras está en curso = NORMAL, no alarma) -->
      <div class="det-row" *ngIf="(t.verificationAttempts || 0) > 0 && t.status === 'SENT'">
        <span>Verificaciones del cron</span><b>{{ t.verificationAttempts }}</b>
      </div>
    </div>

    <!-- Remitente -->
    <div class="det-block">
      <div class="det-title">Remitente</div>
      <div class="det-row"><span>ID usuario</span><b class="mono">{{ t.remitente.usuarioId }}</b></div>
      <div class="det-row"><span>Nombre</span><b>{{ t.remitente.nombre || '—' }}</b></div>
      <div class="det-row"><span>Email</span><b style="color:#2563eb;">{{ t.remitente.email || '—' }}</b></div>
    </div>

    <!-- Beneficiario -->
    <div class="det-block">
      <div class="det-title">Beneficiario</div>
      <div class="det-row"><span>Nombre</span><b>{{ t.beneficiarioDetalle?.nombre || t.beneficiario || '—' }}</b></div>
      <div class="det-row"><span>Documento</span><b>{{ t.beneficiarioDetalle?.tipoId }} {{ t.beneficiarioDetalle?.numeroId || '—' }}</b></div>
      <div class="det-row"><span>Banco</span><b>{{ t.beneficiarioDetalle?.banco || '—' }}</b></div>
      <div class="det-row"><span>Cuenta</span><b style="color:#2563eb;">{{ t.beneficiarioDetalle?.cuentaMask || '—' }}</b></div>
      <div class="det-row"><span>Rail</span><b>{{ t.beneficiarioDetalle?.variante || t.rail }}</b></div>
    </div>

    <!-- Resolución / motivo de rechazo (operador). SOLO casos con problema o
         cierre: FAILED, en revisión, o errorDetail. Una SENT en curso con N
         verificaciones del cron es NORMAL y no debe verse como alarma roja. -->
    <div *ngIf="t.errorDetail || t.status === 'FAILED' || t.status === 'REQUIRES_HUMAN_REVIEW'"
      style="background:#fef2f2;border:1px solid #fecaca;border-radius:12px;padding:14px 16px;margin:4px 0;">
      <div style="font-size:0.66rem;font-weight:700;color:#b91c1c;text-transform:uppercase;letter-spacing:0.4px;margin-bottom:8px;">
        Detalle de resolución
      </div>
      <div class="det-row" *ngIf="t.errorDetail">
        <span>Motivo</span><b style="color:#b91c1c;text-align:right;max-width:340px;">{{ t.errorDetail }}</b>
      </div>
      <div class="det-row" *ngIf="(t.verificationAttempts || 0) > 0">
        <span>Intentos de verificación</span><b>{{ t.verificationAttempts }}</b>
      </div>
      <div class="det-row" *ngIf="t.completedAt">
        <span>Cerrada</span><b>{{ t.completedAt | date:'dd/MM/yyyy HH:mm' }}</b>
      </div>
    </div>

    <!-- Interno (operador) -->
    <div style="background:#0f172a;border-radius:12px;padding:14px 16px;margin-top:4px;">
      <div style="font-size:0.66rem;font-weight:700;color:#fbbf24;text-transform:uppercase;letter-spacing:0.4px;margin-bottom:8px;">🔒 Interno — no cliente</div>
      <div style="display:flex;justify-content:space-between;font-size:0.82rem;color:#e2e8f0;padding:3px 0;"><span style="color:#94a3b8;">Tasa pública</span><b>{{ t.interno.tasaPublica != null ? (t.interno.tasaPublica | number:'1.0-0') : '—' }}</b></div>
      <div style="display:flex;justify-content:space-between;font-size:0.82rem;color:#e2e8f0;padding:3px 0;"><span style="color:#94a3b8;">Tasa partner</span><b>{{ t.interno.tasaPartner != null ? (t.interno.tasaPartner | number:'1.0-0') : '—' }}</b></div>
      <div style="display:flex;justify-content:space-between;font-size:0.82rem;color:#e2e8f0;padding:3px 0;"><span style="color:#94a3b8;">Comisión + fee</span><b>{{ t.interno.comisionFeeCop != null ? (t.interno.comisionFeeCop | number:fmtDe(t)) + ' ' + monedaDe(t) : '—' }}</b></div>
      <div style="display:flex;justify-content:space-between;font-size:0.82rem;border-top:1px solid #1e293b;margin-top:6px;padding-top:6px;"><span style="color:#94a3b8;">Ganancia estimada (cotización)</span><b style="color:#e2e8f0;">{{ t.interno.gananciaUsd != null ? (t.interno.gananciaUsd | number:'1.2-2') + ' USD' : '—' }}</b></div>
      <!-- WS3.2: la REAL = montoUsd − USD enviados a Vita (caja firme solo en COMPLETED) -->
      <div style="display:flex;justify-content:space-between;font-size:0.9rem;padding:3px 0;"><span style="color:#86efac;font-weight:700;">Ganancia real (caja)</span><b style="color:#86efac;">{{ t.interno.gananciaRealUsd != null ? (t.interno.gananciaRealUsd | number:'1.2-2') + ' USD' : '—' }}</b></div>
    </div>

    <!-- Resolución manual (WS3.1) — SOLO si está en revisión humana -->
    <div *ngIf="enRevision" style="background:#faf5ff;border:1px solid #e9d5ff;border-radius:12px;padding:14px 16px;margin-top:12px;">
      <div style="display:flex;align-items:center;gap:6px;font-size:0.8rem;font-weight:700;color:#6d28d9;margin-bottom:6px;">
        <mat-icon style="font-size:18px;width:18px;height:18px;">gavel</mat-icon>
        Resolver esta operación
      </div>
      <p style="font-size:0.76rem;color:#6b7280;margin:0 0 12px;">
        Verificá en el panel de <b>Vita</b> (order <b class="mono">{{ t.txId }}</b>{{ t.vitaTxId ? ', id ' + t.vitaTxId : '' }}) si el pago salió, y cerrala acá.
      </p>

      <div *ngIf="resolverError" style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:8px 12px;margin-bottom:10px;">
        <span style="color:#b91c1c;font-size:0.8rem;font-weight:600;">{{ resolverError }}</span>
      </div>

      <!-- Acciones -->
      <div *ngIf="!mostrarRechazo" class="flex gap-2 flex-wrap">
        <button type="button" (click)="confirmarEnviada()" [disabled]="resolviendo"
          [style.opacity]="resolviendo ? 0.6 : 1"
          style="flex:1;min-width:170px;display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:44px;padding:10px 16px;background:#1C593D;color:white;border:none;border-radius:10px;font-weight:700;font-size:0.84rem;cursor:pointer;transition:background 0.2s ease;"
          onmouseover="if(!this.disabled) this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size:16px;width:16px;height:16px;color:white;">check_circle</mat-icon>
          {{ resolviendo === 'ENVIADA' ? 'Confirmando…' : 'Confirmar ENVIADA' }}
        </button>
        <button type="button" (click)="abrirRechazo()" [disabled]="resolviendo || rechazoBloqueado"
          data-test="btn-rechazar"
          [attr.title]="rechazoBloqueado ? motivoRechazoBloqueado : null"
          [style.opacity]="(resolviendo || rechazoBloqueado) ? 0.6 : 1"
          [style.cursor]="rechazoBloqueado ? 'not-allowed' : 'pointer'"
          style="flex:1;min-width:170px;display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:44px;padding:10px 16px;background:#dc2626;color:white;border:none;border-radius:10px;font-weight:700;font-size:0.84rem;cursor:pointer;transition:background 0.2s ease;"
          onmouseover="if(!this.disabled) this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
          <mat-icon style="font-size:16px;width:16px;height:16px;color:white;">block</mat-icon>
          Rechazar…
        </button>
        <!-- Remesas CLP (25/10/2026): según exista o no el débito en balances -->
        <button *ngIf="puedeReanudar" type="button" (click)="reanudar()" [disabled]="resolviendo"
          data-test="btn-reanudar"
          [style.opacity]="resolviendo ? 0.6 : 1"
          style="flex:1;min-width:170px;display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:44px;padding:10px 16px;background:#2563eb;color:white;border:none;border-radius:10px;font-weight:700;font-size:0.84rem;cursor:pointer;">
          <mat-icon style="font-size:16px;width:16px;height:16px;color:white;">play_circle</mat-icon>
          {{ resolviendo === 'REANUDAR' ? 'Reanudando…' : 'Reanudar pago' }}
        </button>
        <button *ngIf="puedeAnular" type="button" (click)="anular()" [disabled]="resolviendo"
          data-test="btn-anular"
          [style.opacity]="resolviendo ? 0.6 : 1"
          style="flex:1;min-width:170px;display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:44px;padding:10px 16px;background:#6b7280;color:white;border:none;border-radius:10px;font-weight:700;font-size:0.84rem;cursor:pointer;">
          <mat-icon style="font-size:16px;width:16px;height:16px;color:white;">cancel</mat-icon>
          {{ resolviendo === 'ANULAR' ? 'Anulando…' : 'Anular (sin débito)' }}
        </button>
      </div>
      <p *ngIf="!mostrarRechazo && rechazoBloqueado" data-test="motivo-rechazo-bloqueado"
        style="font-size:0.74rem;color:#6b7280;margin:8px 0 0;">
        {{ motivoRechazoBloqueado }}
      </p>
      <p *ngIf="!mostrarRechazo && enRevision && origenClp && t.debitoClp == null" data-test="debito-desconocido"
        style="font-size:0.74rem;color:#b45309;margin:8px 0 0;">
        No se pudo verificar el débito CLP de esta remesa: recargá antes de resolver.
      </p>

      <!-- Form de rechazo (motivo obligatorio; la confirmación fuerte es el Swal) -->
      <div *ngIf="mostrarRechazo">
        <label style="display:block;font-size:0.74rem;font-weight:700;color:#374151;margin-bottom:4px;">
          Motivo del rechazo <span style="color:#dc2626;">*</span> <span style="font-weight:400;color:#9ca3af;">(lo ve el cliente, máx. 150)</span>
        </label>
        <textarea [(ngModel)]="motivo" maxlength="150" rows="2"
          placeholder="Ej: La orden no figura en Vita; pago no ejecutado."
          style="width:100%;padding:10px 12px;border:1.5px solid #fca5a5;border-radius:10px;font-size:0.84rem;outline:none;resize:vertical;box-sizing:border-box;"></textarea>
        <div style="font-size:0.68rem;color:#9ca3af;text-align:right;margin:2px 0 8px;">{{ motivo.length }}/150</div>
        <div class="flex gap-2 flex-wrap">
          <button type="button" (click)="cancelarRechazo()" [disabled]="resolviendo"
            style="display:inline-flex;align-items:center;gap:6px;min-height:44px;padding:10px 18px;background:white;color:#374151;border:1px solid #d1d5db;border-radius:10px;font-weight:600;font-size:0.82rem;cursor:pointer;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            Cancelar
          </button>
          <button type="button" (click)="rechazar()" [disabled]="resolviendo || !motivo.trim()"
            [style.opacity]="(resolviendo || !motivo.trim()) ? 0.5 : 1"
            [style.cursor]="(resolviendo || !motivo.trim()) ? 'not-allowed' : 'pointer'"
            style="flex:1;min-width:200px;display:inline-flex;align-items:center;justify-content:center;gap:6px;min-height:44px;padding:10px 16px;background:#dc2626;color:white;border:none;border-radius:10px;font-weight:700;font-size:0.84rem;transition:background 0.2s ease;"
            onmouseover="if(!this.disabled) this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
            <mat-icon style="font-size:16px;width:16px;height:16px;color:white;">undo</mat-icon>
            <ng-container *ngIf="resolviendo === 'RECHAZADA'">Rechazando…</ng-container>
            <ng-container *ngIf="resolviendo !== 'RECHAZADA'">
              Rechazar y devolver
              <ng-container *ngIf="t.origen.moneda === 'CLP'">{{ t.montoOrigen | number:'1.0-0' }} CLP</ng-container>
              <ng-container *ngIf="t.origen.moneda !== 'CLP'">{{ t.montoUsd | number:'1.2-2' }} USDT</ng-container>
            </ng-container>
          </button>
        </div>
      </div>
    </div>

    <div class="flex justify-end mt-5">
      <button type="button" (click)="close()" [disabled]="resolviendo"
        style="display:inline-flex;align-items:center;gap:6px;padding:8px 24px;background:white;color:#374151;border:1px solid #d1d5db;border-radius:10px;font-weight:600;font-size:0.85rem;cursor:pointer;transition:all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        Cerrar
      </button>
    </div>
  </div>
</div>
